module.exports = __webpack_public_path__ + "static/media/upload-file.83c29c6a.svg";